import { schema } from 'normalizr';
import { createAction } from 'redux-api-middleware';
import { handleResponse, handleError } from '../utils';

export const FETCH_CONTRACT_STATS_REQUEST = 'FETCH_CONTRACT_STATS_REQUEST';
export const FETCH_CONTRACT_STATS_SUCCESS = 'FETCH_CONTRACT_STATS_SUCCESS';
export const FETCH_CONTRACT_STATS_FAILURE = 'FETCH_CONTRACT_STATS_FAILURE';

export const FETCH_STAGED_TRANSACTION_SUMMARY_REQUEST = 'FETCH_STAGED_TRANSACTION_SUMMARY_REQUEST';
export const FETCH_STAGED_TRANSACTION_SUMMARY_SUCCESS = 'FETCH_STAGED_TRANSACTION_SUMMARY_SUCCESS';
export const FETCH_STAGED_TRANSACTION_SUMMARY_FAILURE = 'FETCH_STAGED_TRANSACTION_SUMMARY_FAILURE';

const statsSchema = new schema.Entity('stats', {});

/**
 * Returns a redux api middleware action that makes a request to fetch contract stats.
 *
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchContractStats = () =>
  createAction({
    endpoint: `${window.config.sapiUrl}/stats/contract-stats`,
    method: 'GET',
    types: [
      { type: FETCH_CONTRACT_STATS_REQUEST },
      {
        type: FETCH_CONTRACT_STATS_SUCCESS,
        payload: (action, state, res) => handleResponse([statsSchema], action, state, res),
      },
      { type: FETCH_CONTRACT_STATS_FAILURE, payload: handleError },
    ],
  });

export const fetchStagedTransactionSummary = () =>
  createAction({
    endpoint: `${window.config.sapiUrl}/stats/staged-transactions`,
    method: 'GET',
    types: [
      { type: FETCH_STAGED_TRANSACTION_SUMMARY_REQUEST },
      {
        type: FETCH_STAGED_TRANSACTION_SUMMARY_SUCCESS,
        payload: (action, state, res) => res.json(),
      },
      { type: FETCH_STAGED_TRANSACTION_SUMMARY_FAILURE, payload: handleError },
    ],
  });
